import { render, staticRenderFns } from "./BookmarkModal.vue?vue&type=template&id=49268de1&"
import script from "./BookmarkModal.vue?vue&type=script&lang=js&"
export * from "./BookmarkModal.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports